import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@dhn/lib/utils";

// Opciones del menú permitidas. Por defecto en orden alfabético por su texto
// visible; con `sortAlphabetically={false}` se respeta el orden de los permisos.
const getMenuItems = (permissionViews = [], menuConfig, sortAlphabetically) => {
  const items = permissionViews
    .filter((perm) => menuConfig[perm.name])
    .map((perm) => ({ name: perm.name, config: menuConfig[perm.name] }));

  if (!sortAlphabetically) return items;

  return items.sort((left, right) =>
    left.config.label.localeCompare(right.config.label, "es", { sensitivity: "base" }),
  );
};

export default function NavMenu({
  permissionViews,
  pathname,
  menuConfig,
  sortAlphabetically = true,
}) {
  const menuItems = useMemo(
    () => getMenuItems(permissionViews || [], menuConfig, sortAlphabetically),
    [permissionViews, menuConfig, sortAlphabetically],
  );

  return (
    <div className="doctor-office-menu">
      {menuItems.map(({ name, config }) => {
        const isActive = pathname === config.path;

        return (
          <NavLink
            key={name}
            to={config.path}
            className={cn(
              "doctor-office-menu__link tw-group tw-flex tw-min-h-10 tw-items-center tw-gap-2 tw-rounded-md tw-border tw-border-transparent tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-600 tw-no-underline tw-transition-colors hover:tw-border-clinic-line hover:tw-bg-clinic-surface hover:tw-text-clinic-teal xl:tw-min-h-9",
              isActive &&
                "doctor-office-menu__link--active tw-border-cyan-200 tw-bg-cyan-50 tw-text-red-700 tw-shadow-sm",
            )}
          >
            <span
              className={cn(
                "doctor-office-menu__icon tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-bg-slate-100 tw-text-clinic-teal tw-transition-colors group-hover:tw-bg-white",
                isActive && "tw-bg-white tw-text-red-700",
              )}
            >
              <i className={`fa ${config.icon}`} />
            </span>
            <span className="tw-truncate">{config.label}</span>
          </NavLink>
        );
      })}
    </div>
  );
}
